// 消息
import request from '@/utils/request'
// 获取消息列表
export function getMessageData(params) {
  return request({
    url: '/msg-server/msg/getWebList',
    method: 'get',
    params: params
  })
}
// 设置消息已读
export function setMessageStatus(params) {
  return request({
    url: `/msg-server/msg/readed/${params.id}`,
    method: 'get',
    params: params
  })
}
// 详情
export function getId(params) {
  return request({
    url: `/msg-server/msg/get/${params.id}`,
    method: 'get',
    params: params
  })
}

// 获取今日报警数据
export function getWarningData(params) {
  return request({
    url: '/znxj/getEarlyWarningCnt',
    method: 'post',
    data: params
  })
}




// WEBPACK FOOTER //
// ./src/api/message.js